<template>
  <div class="uebungen-library">
      <!-- Spread-Animation Overlay für Modals -->
      <div v-if="isAnimating" 
      class="spread-overlay" 
      :class="{ 'active': showCreateModal || showAbsolveModal || showPrintModal  }, `spread-overlay_${activeModal}`" 
      :style="{
        '--spread-x': spreadPosition.x + 'px',
        '--spread-y': spreadPosition.y + 'px'
      }"></div>
      
      <uebungen-library-dashboard v-if="activeStep === 'dashboard'" @uebungen-library__set-active-step="setActiveStep"></uebungen-library-dashboard>
      <uebungen-library-create-uebung v-else-if="activeStep === 'create-uebung'" @uebungen-library__set-active-step="setActiveStep"></uebungen-library-create-uebung>
      <uebungen-library-category-uebung-classic-create v-else-if="activeStep === 'uebungen-library-category-uebung-classic-create'" @uebungen-library__set-active-step="setActiveStep"></uebungen-library-category-uebung-classic-create>
      
      <!-- Create-Modal -->
      <transition name="modal">
        <uebungen-library-create-uebung-modal 
          v-if="showCreateModal" 
          @close-create-uebung-modal="closeCreateModal">
        </uebungen-library-create-uebung-modal>
      </transition>

      <!-- Edit-Modal -->
      <transition name="modal">
        <uebungen-library-edit-uebung-modal 
          v-if="showEditModal && currentUebung" 
          :uebung="currentUebung"
          @close-edit-uebung-modal="closeEditModal">
        </uebungen-library-edit-uebung-modal>
      </transition>
      
      <!-- Absolve-Modal -->
      <transition name="modal">
        <uebungen-library-absolve-uebung-modal 
          v-if="showAbsolveModal && currentUebung" 
          :uebung="currentUebung"
          @close-absolve-uebung-modal="closeAbsolveModal">
        </uebungen-library-absolve-uebung-modal>
      </transition>
      
      <!-- Print-Modal -->
      <transition name="modal">
        <uebungen-library-print-uebung-modal 
          v-if="showPrintModal && currentUebung" 
          :uebung="currentUebung"
          @close-print-uebung-modal="closePrintModal">
        </uebungen-library-print-uebung-modal>
      </transition>
  </div>
</template>

<script>

import UebungenLibraryDashboard from "@/uebungen-library/components/UebungenLibraryDashboard.vue";
import UebungenLibraryCreateUebung from "@/uebungen-library/components/UebungenLibraryCreateUebung.vue";
import UebungenLibraryCategoryUebungClassicCreate from "@/uebungen-library/components/UebungenLibraryCategoryUebungClassicCreate.vue";
import UebungenLibraryCreateUebungModal from "@/uebungen-library/components/UebungenLibraryCreateUebungModal.vue";
import UebungenLibraryAbsolveUebungModal from "@/uebungen-library/components/UebungenLibraryAbsolveUebungModal.vue";
import UebungenLibraryEditUebungModal from "@/uebungen-library/components/UebungenLibraryEditUebungModal.vue";
import UebungenLibraryPrintUebungModal from "@/uebungen-library/components/UebungenLibraryPrintUebungModal.vue";
import {EventBus} from "@/hermeneus.eventbus/eventbus.js";


export default {
  name: 'uebungen-library',
  props: {
  },
  data() {
    return {
      showCreateModal: false,
      showAbsolveModal: false,
      showPrintModal: false,
      showEditModal: false,
      activeStep: 'dashboard',
      modalData: {
        title: 'asd',
        componentPath: 'resources/vue/UebungTestCreateComponent.vue',
        moduleName: 'UebungTest',
      },
      currentUebung: null,
      isAnimating: false,
      spreadPosition: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    activeModal() {
      return this.showCreateModal ? 'create' : this.showAbsolveModal ? 'absolve' : this.showPrintModal ? 'print' : null;
    },
    registeredCategories() {
      return this.$UebungenRegistry.registered_categories;
    },
    registeredUebungen() {
      return this.$UebungenRegistry.registered_uebungen;
    },
  },
  methods: {
    setActiveStep(step) {
      this.activeStep = step;
    },
    filteredUebungen(categoryKey) {
      return Object.values(this.registeredUebungen).filter(uebung => uebung.category === categoryKey);
    },
    openCreateModal(position) {
      // Setze die Position für die Spread-Animation
      this.spreadPosition = position;
      
      // Starte die Animation und öffne das Modal mit Verzögerung
      this.isAnimating = true;
      setTimeout(() => {
        this.showCreateModal = true;
      }, 300);
    },
    closeCreateModal() {
      this.showCreateModal = false;
      setTimeout(() => {
        this.isAnimating = false;
      }, 600);
      
      // Aktualisiere die Übungen nach dem Schließen des Modals
      EventBus.$emit('refresh-uebungen-library');
    },
    openAbsolveModal(uebung, position) {
      this.currentUebung = uebung;
      
      // Setze die Position für die Spread-Animation
      this.spreadPosition = position;
      
      // Starte die Animation und öffne das Modal mit Verzögerung
      this.isAnimating = true;
      setTimeout(() => {
        this.showAbsolveModal = true;
      }, 300);
    },
    openEditModal(uebung) {
      this.currentUebung = uebung;
      this.showEditModal = true;
    },
    closeEditModal() {
      this.currentUebung = null;
      this.showEditModal = false;
    },
    closeAbsolveModal() {
      this.showAbsolveModal = false;
      setTimeout(() => {
        this.isAnimating = false;
        this.currentUebung = null;
      }, 600);
    },
    openPrintModal(uebung, position) {
      this.currentUebung = uebung;
      
      // Setze die Position für die Spread-Animation
      this.spreadPosition = position;
      
      // Starte die Animation und öffne das Modal mit Verzögerung
      this.isAnimating = true;
      setTimeout(() => {
        this.showPrintModal = true;
      }, 300);
    },
    closePrintModal() {
      this.showPrintModal = false;
      setTimeout(() => {
        this.isAnimating = false;
        this.currentUebung = null;
      }, 600);
    }
  },
  components: {
    UebungenLibraryDashboard,
    UebungenLibraryCreateUebung,
    UebungenLibraryCategoryUebungClassicCreate,
    UebungenLibraryCreateUebungModal,
    UebungenLibraryAbsolveUebungModal,
    UebungenLibraryEditUebungModal,
    UebungenLibraryPrintUebungModal
  },
  mounted() {
    // Event-Listener für das Create-Modal
    EventBus.$on('openUebungCreateModal', (modalData) => {
      this.modalData = modalData;
      this.showCreateModal = true;
    });
    
    // Event-Listener für das Öffnen des Create-Modals mit Animation
    EventBus.$on('uebungen-library__open-create-modal', (data) => {
      this.openCreateModal(data.position);
    });
    
    // Event-Listener für das Öffnen des Absolve-Modals
    EventBus.$on('uebungen-library__open-absolve-modal', (data) => {
      this.openAbsolveModal(data.uebung, data.position);
    });
    // Event-Listener für das Öffnen des Edit-Modals
    EventBus.$on('uebungen-library__open-edit-modal', (data) => {
      this.openEditModal(data.uebung);
    });
    
    // Event-Listener für das Öffnen des Print-Modals
    EventBus.$on('uebungen-library__open-print-uebung-modal', (data) => {
      this.openPrintModal(data.uebung, data.position);
    });
    
    // Event-Listener für das Schließen der Modals
    EventBus.$on('close-create-uebung-modal', this.closeCreateModal);
    EventBus.$on('close-absolve-uebung-modal', this.closeAbsolveModal);
    EventBus.$on('close-print-uebung-modal', this.closePrintModal);
  },
  beforeDestroy() {
    // Event-Listener entfernen
    EventBus.$off('openUebungCreateModal');
    EventBus.$off('uebungen-library__open-create-modal');
    EventBus.$off('uebungen-library__open-absolve-modal');
    EventBus.$off('uebungen-library__open-print-uebung-modal');
    EventBus.$off('close-create-uebung-modal');
    EventBus.$off('close-absolve-uebung-modal');
    EventBus.$off('close-print-uebung-modal');
  }
};
</script>

<style scoped>

button {
  transition: background-color 0.3s ease;
}

/* Mit Background-Color wird die Farbe des Overlays definiert */
.spread-overlay {
  position: fixed;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 90;
  left: var(--spread-x);
  top: var(--spread-y);
  pointer-events: none; 
}
.spread-overlay_create, .spread-overlay_absolve {
  background-color: theme('colors.primary-700');
}
.spread-overlay_print {
  background-color: theme('colors.white');
}

.spread-overlay.active {
  width: 300vmax;
  height: 300vmax;
  transform: translate(-50%, -50%);
}
.spread-overlay_create.active, .spread-overlay_absolve.active {
  background-color: theme('colors.primary-700');
}
.spread-overlay_print.active {
  background-color: theme('colors.white');
}

/* Modal Transitions */
.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
